import { Button, Form, Modal } from 'antd';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import {
  OpenClass,
  OpenClassRegistrationSelectionParams,
} from '../../openClasses/types/OpenClass';
import { RegistrationDraft } from '../utils/openClassParticipantDraft';
import OpenClassAssignmentFields, {
  OpenClassAssignmentFormValues,
} from './OpenClassAssignmentFields';

type OpenClassRegistrationModalProps = {
  open: boolean;
  openClasses: OpenClass[];
  registration?: RegistrationDraft;
  // Classes the participant already has a registration for, so a duplicate cannot be picked.
  disabledOpenClassIds?: number[];
  onSave: (selection: OpenClassRegistrationSelectionParams) => void;
  onClose: () => void;
};

const OpenClassRegistrationModal: React.FC<OpenClassRegistrationModalProps> = ({
  open,
  openClasses,
  registration,
  disabledOpenClassIds,
  onSave,
  onClose,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm<OpenClassAssignmentFormValues>();

  useEffect(() => {
    if (!open) return;
    form.resetFields();
    if (registration) {
      form.setFieldsValue({
        certificateTemplateId: registration.certificateTemplateId,
        openClassId: registration.openClassId,
        sessionIds: registration.sessionIds,
      });
    }
  }, [form, open, registration]);

  const submit = (values: OpenClassAssignmentFormValues) => {
    onSave({
      certificateTemplateId: values.certificateTemplateId!,
      openClassId: values.openClassId!,
      sessionIds: values.sessionIds ?? [],
    });
    onClose();
  };

  return (
    <Modal
      open={open}
      title={
        registration
          ? t('views.OpenClassBookingOrderDetails.editRegistration')
          : t('views.OpenClassBookingOrderDetails.addRegistration')
      }
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          {t('common.close')}
        </Button>,
        <Button key="submit" type="primary" onClick={() => form.submit()}>
          {t('common.save')}
        </Button>,
      ]}
      maskClosable={false}>
      <Form form={form} layout="vertical" onFinish={submit}>
        <OpenClassAssignmentFields
          disabledOpenClassIds={disabledOpenClassIds}
          disableOpenClass={registration?.registrationId != null}
          form={form}
          openClasses={openClasses}
          retainedOpenClassId={registration?.openClassId}
        />
      </Form>
    </Modal>
  );
};

export default OpenClassRegistrationModal;
